import { useEffect, useState } from 'react'
import { WalletModel } from 'src/common/api'
import { getOrganizationProfile, getOrganizationBalances } from 'src/common/api/organizations'
import { useAuth } from '../auth'

export interface BlockchainContext {
  loading: boolean
  wallets: WalletModel[]
  fetchBlockchainDetails: () => Promise<void>
}

const useProvideBlockchain = (): BlockchainContext => {
  const { user } = useAuth()
  const [walletsLoading, setWalletsLoading] = useState(true)
  const [wallets, setWallets] = useState<WalletModel[]>([])

  const fetchBlockchainDetails = async () => {
    if (!user?.organization) {
      setWallets([])
      setWalletsLoading(false)
      return
    }

    try {
      setWalletsLoading(true)
      const [response, balanceResponse] = await Promise.all([getOrganizationProfile(), getOrganizationBalances()])
      const blockchainDetails = response.data.blockchainDetails || []
      const balances = balanceResponse?.data || {}

      // Transform BlockchainDetailsModel to WalletModel format for display
      const transformedWallets: WalletModel[] = blockchainDetails.map((detail) => ({
        id: detail.id,
        address: detail.address,
        name: detail.name,
        chain: detail.chain,
        balance: balances[detail.address]
      }))
      setWallets(transformedWallets)
    } catch (err) {
      console.error('Failed to fetch organization blockchain details:', err)
      setWallets([])
    } finally {
      setWalletsLoading(false)
    }
  }

  useEffect(() => {
    fetchBlockchainDetails()
  }, [user?.organization])

  return {
    loading: walletsLoading,
    wallets: wallets,
    fetchBlockchainDetails
  }
}

export default useProvideBlockchain
